import type { ComponentType, SVGProps } from 'react';
import { Box, Typography } from '@mui/material';
import SearchData from '../../../resources/icons/search-data.svg?react';

type Props = {
  GraphComponent?: ComponentType<SVGProps<SVGSVGElement>>;
};

/** Same look as `NoDataSelected`, built entirely from MUI components instead of a scss file. */
function NoDataSelectedMUI({
  GraphComponent = SearchData,
}: Props): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        opacity: 0.4,
        gap: theme.lelySpacing.SM,
        color: theme.palette.text.secondary,
      })}
    >
      <GraphComponent
        style={{ boxSizing: 'content-box', width: 20, height: 20 }}
      />
      <Typography variant="caption" sx={{ color: 'inherit' }}>
        No data selected
      </Typography>
    </Box>
  );
}

export default NoDataSelectedMUI;
